module.exports = __webpack_public_path__ + "static/media/defaultAvatar9.5b337f4f.svg";